import { useMutation, useQueryClient } from '@tanstack/react-query';
import BirthService, {
  ICreateBirthParams,
} from '@clickersphere/core/services/BirthService';
import { useBuildQueryKey } from '../useBuildQueryKey';
import { LEADS_QUERY_KEY } from '../lead/useLeads';
import { BIRTHS_QUERY_KEY, BirthQueryData } from './useBirths';

export function useCreateBirth() {
  const queryClient = useQueryClient();
  const { buildQueryKey } = useBuildQueryKey();

  const { isPending: createBirthIsPending, mutateAsync: createBirthAsync } =
    useMutation({
      mutationFn: async (data: ICreateBirthParams) => {
        const birth = await BirthService.create(data);
        return birth as BirthQueryData;
      },
      onSuccess: async (_data, variables) => {
        await queryClient.invalidateQueries({
          queryKey: buildQueryKey(BIRTHS_QUERY_KEY),
        });
        await queryClient.invalidateQueries({
          queryKey: buildQueryKey([LEADS_QUERY_KEY, variables.leadId]),
        });
      },
    });

  return {
    createBirthAsync,
    createBirthIsPending,
  };
}
